import { Routes } from '@angular/router';
export const SIGNATURE_REQUESTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import ('./pages/signature-request-list-page/signature-request-list-page.component').then(m => m.SignatureRequestListPageComponent)
    },
    {
        path: ':id',
        loadComponent: () => import ('./pages/signature-request-detail-page/signature-request-detail-page.component').then(m => m.SignatureRequestDetailPageComponent)
    }
]